import { Skeleton } from '@/components/ui';

export function SettingsNotificationsSkeleton() {
  return (
    <div className="flex flex-col gap-6 px-5 py-6">
      {/* Toggle cards */}
      {[0, 1].map((i) => (
        <div
          key={i}
          className="flex items-center justify-between border border-border rounded-xl p-4"
        >
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3.5 w-52" />
          </div>
          <Skeleton className="h-6 w-10 rounded-full" />
        </div>
      ))}

      {/* Footer text */}
      <Skeleton className="h-3.5 w-56 mx-auto" />
    </div>
  );
}
